import './markdown-view.css';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * 統一的 Markdown 渲染元件（GFM 支援：表格、待辦清單、刪除線等）。
 * 供稽核報告讀態板塊使用，後續可透過 CSS className 統一調整排版樣式。
 */
export function MarkdownView({ markdown }: { markdown: string }) {
  return (
    <div className="zhcb-md">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
    </div>
  );
}
